import React, { useState, useEffect, useMemo } from "react";
import _ from "lodash";

import {
  TextField,
  Tab,
  Tabs,
    Grid,  Box, Typography, Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem

} from "@mui/material";
import LocationList from "../components/gbp/locationlist";
import ReactJson from "react-json-view";

const initialCache = {};

const Gbp = ({userRoles, selectedLocation, selectedCompany }) => {
  const isIRUser = React.useMemo(
    () => userRoles?.indexOf("IRUser") >= 0,
    [userRoles]
  );

  
  const [selectedAccount, setSelectedAccount] = useState('');
  const [selectedTab, setSelectedTab] = useState(0);
    const [accountData, setAccountData] = useState('');


  
  const accountList = useMemo(()=>{
      const dt = _.map(selectedAccount, a=>a?.accountId)
        return _.uniq(dt);
  },[selectedAccount])


  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };



  return (
    <div style={{ paddingTop: '14px' }}>
      <Grid container columns={6} >
        <Grid
          item
          xs={3}
          sx={{
            borderRight: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
           {/* <FormControl size="small" sx={{minWidth: 300, mt:1}}>
                <InputLabel id="demo-simple-select-label">Select Account</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={accountData}
                label="Select Account"
                onChange={(e)=>setAccountData(e.target.value)}
                >
                    {_.map(selectedAccount, (account) => (<MenuItem value={account?.accountId}>{account}</MenuItem>))}
                
                
                </Select>
            </FormControl> */}
          <Box sx={{marginRight:2, marginTop:'44px'}}>
            <LocationList selectedAccount={selectedAccount} setSelectedAccount={setSelectedAccount} companyId={selectedCompany?.companyId} userRoles={userRoles} />
          </Box>
        </Grid>

        <Grid item xs={3}>
          <Box sx={{mt:2}}>
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              sx={{ borderBottom: "1px solid #888", pt: 0.5 }}
            >
              <Tab
                value={0}
                sx={{ textTransform: "none" }}
                label="Details"
              />
             
              {/* <Tab value={2} sx={{ textTransform: "none" }} label="Reviews" /> */}

              
            </Tabs>

            <div>
            

                {selectedTab === 0 && (
                    <Box sx={{ p: 2 }}>
                        <ReactJson
                            style={{
                                // marginTop: "20px",
                                whiteSpace: "pre-wrap",
                                // border: "1px solid #ccc",
                                minHeight: '100px',
                                overflow: 'auto',
                                minHeight: 'calc(100vh - 250px)',
                                maxHeight: "calc(100vh - 250px)"
                            }}
                            src={selectedAccount || {}}
                            name={null}
                            theme="rjv-default"
                            collapsed={false}
                            enableClipboard={false}
                            displayDataTypes={false}
                            />
                    </Box>
                )}

            </div>
          </Box>
        </Grid>
      </Grid>

    
    </div>
  );
};

export default Gbp;
